import React from "react";
import { fetchSubscriberReplies } from "../../../actions/subscribeToPet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AvatarEditor from "react-avatar-editor";
import history from "../../../history.js";
import moment from "moment";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import "react-select/dist/react-select.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import Responsive from "react-responsive";
import config from "../../../config";
import _ from "lodash";
import Store from "../../../store";

const $ = window.$;
const { SearchBar } = Search;

const petAvailabilityStatus = {
  available: "available",
  sold: "sold",
};

const orientation = window.matchMedia("(max-width: 700px)").matches ? "vertical" : "horizontal";

const userPermissionList = {
  listSocialMediaSubmission : 'list-social-media-submission',
};

class SubscriberReplies extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    subscriberReplies: [],
    listSocialMediaSubmissionFlag:[],
    loadingBd : null,
  };

  tableHeaderColumnData = [
    {
      dataField: "SubscribeToPet.mobileNo",
      text: "Mobile No",
      sort: true,
    },
    {
      dataField: "message",
      text: "Message",
      sort: true,
      formatter: (cell) => cell
    }
  ];

  componentDidMount() {
    this.props.fetchSubscriberReplies();
    this.loadPermissions();
    this.setState({ loadingBd : true });
  }

  loadPermissions(){  
    let allPermission = JSON.parse( localStorage.getItem('userPermissions')) ; 
      if(allPermission && allPermission.length > 0){ 
          const listSocialMediaSubmission =  allPermission.find(item => item.Module.module_name == userPermissionList.listSocialMediaSubmission);            
          this.setState({ listSocialMediaSubmissionFlag: listSocialMediaSubmission ? listSocialMediaSubmission.value : true,});
      }
    
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.subscribeToPetReducer.subscriberReplies !==
      this.props.data.subscribeToPetReducer.subscriberReplies
    ) {
      let subscriberReplies = nextProps.data.subscribeToPetReducer.subscriberReplies;

      this.setState({
        subscriberReplies: subscriberReplies,
        loadingBd: false,
      });
    }
  };

  async componentDidUpdate(prevProps, prevState) {}

  items = [{ title: "Subscribe Replies", to: "/subscriber-replies" }];

  render() {
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Subscribe Replies
                        <small>List of all the subscriber replies</small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body medical-record-content subscribe-to-pet-table">
                  <div className="tab-content">
                    { !this.state.loadingBd ?
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.subscriberReplies}
                      columns={this.tableHeaderColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {(props) => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                              <i className="fas fa-search mt-1"></i>
                              <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the medical record, please make sure your
                              cache is cleared and completed a hard refresh. IOS users might have to use a private
                              window.
                            </small>
                          </div>
                          <BootstrapTable classes="petTable" {...props.baseProps} pagination={paginationFactory()} />
                        </div>
                      )}
                    </ToolkitProvider>:
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = (state) => ({
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
    fetchSubscriberReplies: () => {
    dispatch(fetchSubscriberReplies());
  },
});

SubscriberReplies = connect(mapStateToProps, mapDispatchToProps)(SubscriberReplies);

export default withRouter(SubscriberReplies);
